<template>
  <Skeleton v-if="!professors.length" min-height="120px"/>
  <ClSlider v-else :items="professorsHasImage" >
    <template #item="{item}">
      <ProfessorSliderItem :item="item" />
    </template>
  </ClSlider>
</template>


<script>
import ClSlider from "@/components/base/ClSlider.vue";
import ProfessorSliderItem from "@/components/professors/ProfessorSliderItem.vue";
import RepositoryFactory from "@/repositories/RepositoryFactory";
import Skeleton from "@/components/common/Skeleton.vue";

export default {
  components: {Skeleton, ProfessorSliderItem, ClSlider},
  emits: ['finishedProfSliderLoading'],

  data() {
    return {
      ProfessorRepo: RepositoryFactory.get('Professors'),
      professors: [],
    }
  },

  async mounted() {
    this.professors = await this.getProfessors();
  },

  methods:{
    async getProfessors(){
      try {
        // const { data } =  await axios.get(this.$baseUrl + '/professors');
        const { data } =  await this.ProfessorRepo.get();
        this.$emit('finishedProfSliderLoading',true)
        return data;
      }catch(error) {
        console.log("FETCH PROFESSORS ERROR: " + error)
      }
    },
  },
  computed:{
    professorsHasImage(){
      return [...this.professors].filter(prof => prof.profile.user_img_files.img_1)
    }
  }

}
</script>

<style lang="scss">
.v-slide-group__next, .v-slide-group__prev {
  min-width: 32px!important;
}
.slider-next:before, .slider-prev:before {
  cursor: pointer;
  color: #989898;
  opacity: 1;
  font-size: 34px;
}
.img-blur{
  filter: blur(1.5rem);
}

#sliderHorizontal * {
  letter-spacing: 0 !important;
}

#sliderHorizontal::-webkit-scrollbar {
  width: 0 !important;
}
#sliderHorizontal {
  position: relative;
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
  scroll-behavior: smooth;
  overflow: scroll;
  width: auto;
}
#sliderHorizontal {
  .slider-next, .slider-prev {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .slider-next {
    left: 0;
  }

  .slider-prev {
    right: 0;
  }
}

</style>
